import { VaporPageStickable } from "@vapor/react-contrib-tax-compliance";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";
import { useTranslation } from "react-i18next";

/**
 * The other bootstrap dead end: the workspace resolved and its subscriptions
 * came back, but none of them is active. Distinct from `DataNotAvailable`
 * because this one is a fact about the customer's contract, not a failure —
 * which is why a failed subscriptions fetch must never land here.
 */
export const ServiceNotActive = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <VaporPageStickable>
            <Stack justifyContent="center" alignItems="center">
                <Typography
                    variant="h4"
                    color={theme.palette.primary.textTitleColor}
                >
                    {t("components.service_not_active.not_active")}
                </Typography>
            </Stack>
        </VaporPageStickable>
    );
};
